module.exports = __webpack_public_path__ + "img/check.6707355f.svg";